module.exports = __webpack_public_path__ + "img/akinderLogo.b406f561.svg";